export default "__VITE_ASSET__DYf7A_OY__"